import { resolveTemplateIdForRender } from "#/lib/templates/index.js";
import type { TemplateLayoutProps } from "#/lib/templates/types.js";
import { TemplateBentoConsole } from "./TemplateBentoConsole.js";
import { TemplateEditorialLongform } from "./TemplateEditorialLongform.js";
import { TemplateNewsroom } from "./TemplateNewsroom.js";

export function TemplateRouter(props: TemplateLayoutProps) {
  const templateId = resolveTemplateIdForRender(props.templateId);
  switch (templateId) {
    case "bento-console":
      return <TemplateBentoConsole {...props} />;
    case "editorial-longform":
      return <TemplateEditorialLongform {...props} />;
    default:
      return <TemplateNewsroom {...props} />;
  }
}
